/**
 * WYBÓR TOWARU W PLANOGRAMIE — ile pobrać i co powiedzieć, gdy to nie wszystko.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ POWSTAŁO ZE ZGŁOSZENIA I ZMIERZONEGO PRZYPADKU (wyspa DBW, 26.08.2026). Lista towarów
 *  w panelu edycji pobierała `pageSize: 20` i po prostu się KOŃCZYŁA — bez słowa, że jest coś
 *  dalej. Wyspa ma 25 aktywnych towarów, więc scroll dobiegał do:
 *
 *      ostatni widoczny:   REKAWICE SRUTOWNICZE      ← „skończyło się na R"
 *      niewidoczne:        SZYBKA ZEW DO SPEEDGLAS 9100, SZYBKA ZEW. PRZYLBICY SPEEDGL100, …
 *
 *  ⚠️ TO NIE BYŁA WADA KOSMETYCZNA. Lista wygląda na kompletną, bo da się ją przewinąć do końca —
 *  a przewinięcie do końca to jedyny sygnał, jakim człowiek sprawdza, czy czegoś nie ma. Operator
 *  wyciąga z tego wniosek „tego towaru nie ma w systemie" i idzie go zakładać drugi raz.
 *
 *  ⚠️ DWIE NIEZALEŻNE NAPRAWY, bo to dwie różne przyczyny i każda wraca osobno:
 *    1. ROZMIAR STRONY do maksimum, jakie przyjmuje API — realna wyspa mieści się w całości;
 *    2. LICZNIK POD LISTĄ — mówi „pokazano X z Y" ZAWSZE, więc przy wyspie większej niż strona
 *       człowiek widzi, że ma zawęzić, a nie zgaduje. Sam punkt 1 przenosi tylko granicę, przy
 *       której błąd wraca, i to w miejsce, w które nikt nie zajrzy.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

/**
 * MAKSIMUM, JAKIE PRZYJMUJE API (`ListItemsDto`: `.max(200)`).
 *
 * ⚠️ WIĘKSZA LICZBA NIE JEST DROŻSZA W PRAKTYCE, i to jest powód, żeby wziąć maksimum. Zapytanie
 * leci z frazą wyszukiwania, więc odpowiedź ma rozmiar `min(trafień, 200)` — przy pisaniu i tak
 * jest krótka. Duża strona kosztuje jedno pobranie: to z PUSTĄ frazą, czyli dokładnie ten
 * przypadek, w którym człowiek PRZEGLĄDA listę i musi zobaczyć całość.
 */
export const ROZMIAR_STRONY_TOWAROW = 200;

export type PodsumowanieListy = {
  /** Ile pozycji zostało poza listą. `0` = widać wszystko. */
  ukrytych: number;
  /** Czy trzeba powiedzieć człowiekowi, że lista jest ucięta. */
  ucieta: boolean;
};

/**
 * CO POWIEDZIEĆ POD LISTĄ.
 *
 * ⚠️ `razem` MNIEJSZE OD `pokazano` TRAKTUJEMY JAKO BRAK UCIĘCIA. Zdarza się to naturalnie:
 * `total` policzył serwer przed tym, jak ktoś inny usunął towar, więc lista bywa o wiersz dłuższa
 * niż licznik. Ujemna liczba ukrytych na ekranie byłaby gorsza niż zaokrąglenie tego do zera.
 */
export function podsumowanieListy(pokazano: number, razem: number): PodsumowanieListy {
  const ukrytych = Math.max(0, razem - pokazano);
  return { ukrytych, ucieta: ukrytych > 0 };
}
